import 'react-multi-carousel/lib/styles.css';
import "react-vertical-timeline-component/style.min.css";
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import colorSharp from "../assets/img/color-sharp.png";
import colorSharp2 from "../assets/img/color-sharp2.png";
import { FaBriefcase } from "react-icons/fa";

export const WorkExperiences = () => {

  const experiences = [
    {
      company: "Gelecek Varlık Yönetimi",
      role: "Software Engineer",
      period: "December 2023 - Present",
      description: "Currently working as a Full Stack Developer at Gelecek Varlık Yönetimi, contributing to large-scale financial and asset management projects using .NET, React, MSSQL, and MongoDB, implementing scalable, maintainable applications, REST APIs, and AI-powered integrations, while collaborating across teams and contributing to award-winning ERP solutions."
    },
    {
      company: "Hergele Mobility",
      role: "Software Engineer",
      period: "September 2022 - November 2023",
      description: "Worked as a Software Engineer at Hergele Mobility, developing dashboards and fleet management solutions for micro-mobility and IoT projects using .NET MVC, MongoDB, AWS, and REST APIs, ensuring scalable and maintainable systems."
    },
    {
      company: "Yapı Kredi Bank",
      role: "Project Intern",
      period: "August 2022 - September 2022",
      description: "Participated in a one-month development program at Yapı Kredi Bank, gaining hands-on experience with AI, Big Data, and emerging technologies, while enhancing analytical skills and professional development through interactive sessions with industry experts."
    },
    {
      company: "Hergele Mobility",
      role: "Software Intern",
      period: "March 2022 - August 2022",
      description: "Completed my first software internship at Hergele Mobility, collaborating on team projects using .NET MVC and gaining hands-on experience with MongoDB and real-world development workflows."
    },
  ];

  return (
    <section className="workExperience" id="workExperiences">
              <img className="background-image-right" src={colorSharp2} alt="Image" />
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="workExperience-bx wow zoomIn">
                        <h2>Work Experiences</h2>
                        <p>A collaborative software developer who solves complex business problems using modern technologies.</p>

<VerticalTimeline>
  {experiences.map((exp, index) => (
    <VerticalTimelineElement
      key={index}
      contentStyle={{ 
        background: 'linear-gradient(90deg, #a75f8a, #4023c0)', 
        color: '#fff',
        borderRadius: '12px', 
        boxShadow: '0 4px 15px rgba(0,0,0,0.2)', 
      }}
      contentArrowStyle={{ borderRight: '7px solid #4023c0' }}
      date={exp.period}
      iconStyle={{ 
        background: 'linear-gradient(135deg, #ff6ec4, #6a82fb)', 
        color: '#fff',
        borderRadius: '8px', 
        boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
      }}
      icon={<FaBriefcase />}
    >
      <h3 className="vertical-timeline-element-title">{exp.role}</h3>
      <h4 className="vertical-timeline-element-subtitle">{exp.company}</h4>
      <p>{exp.description}</p>
    </VerticalTimelineElement>
  ))}
</VerticalTimeline>


                    </div>
                </div>
            </div>
        </div>
        <img className="background-image-left" src={colorSharp} alt="Image" />
    </section>
  )
}
